import { CACHE_QUERY_PARAM } from "constants/serviceWorker";
import { sha256 } from "utils/common";
import { removeParamFromUrl } from "utils/fetch";

export const addToCache = async (
  cacheName: string,
  req: Request | string,
  res: Response,
  defaultCache?: Cache
) => {
  const cache = defaultCache ?? (await caches.open(cacheName));
  const cacheKey = getCacheKey(req);
  await cache.put(cacheKey, res.clone());
};

export const matchToCache = async (
  cacheName: string,
  req: Request | string,
  defaultCache?: Cache,
  options?: CacheQueryOptions
) => {
  const cache = defaultCache ?? (await caches.open(cacheName));
  const cacheKey = getCacheKey(req);

  return await cache.match(cacheKey, options);
};

export const getCacheKey = (
  req: Request | string,
  isRemoveCacheParam = true
) => {
  let cacheKey = req;
  if (req instanceof Request) {
    cacheKey = req.url;
  }
  if (isRemoveCacheParam) {
    cacheKey = removeParamFromUrl(cacheKey as string, CACHE_QUERY_PARAM);
  }

  return cacheKey;
};
